import React from 'react';

const DismissX = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M9.94326 1.27337L9.00326 0.333374L5.27659 4.06004L1.54992 0.333374L0.609924 1.27337L4.33659 5.00004L0.609924 8.72671L1.54992 9.66671L5.27659 5.94004L9.00326 9.66671L9.94326 8.72671L6.21659 5.00004L9.94326 1.27337Z" fill="#767B8E" />
    </svg>
);

export default DismissX;